/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FeatureFlagRequestBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return FeatureFlagRequestBase.fixupPrototype; }

    static newInstance(model: Partial<FeatureFlagRequestBase>): FeatureFlagRequestBase {
        let obj = Object.assign(new FeatureFlagRequestBase(), model);
        FeatureFlagRequestBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FeatureFlagRequestBase>): FeatureFlagRequestBase {
        if (!model) return null;
        return FeatureFlagRequestBase.newInstance(<FeatureFlagRequestBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FeatureFlagRequestBase) {
        if (!obj) return;

        models.FeatureFlagRequestBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FeatureFlagRequestBase): boolean {
        switch (obj.__type)
        {
            case "FeatureFlagRequest":
                Object.setPrototypeOf(obj, models.FeatureFlagRequest.prototype);
                break;
            case "ReleaseFlagRequest":
                Object.setPrototypeOf(obj, models.ReleaseFlagRequest.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof FeatureFlagRequestBase)[] {
        return [
            models.FeatureFlagRequest,
            models.ReleaseFlagRequest,
        ];
    }

    fixupFields() {
        if (this.context) {
            models.FeatureFlagContext.fixupPrototype(this.context);
        }
    }

    /**
     * The main category of the feature flags
     */
    category: models.FeatureFlagCategory;

    /**
     * Feature flag's name
     */
    flag_name: string;

    /**
     * Feature flag's context
     */
    context: models.FeatureFlagContext;

}
